export default "__VITE_ASSET__D3cRa7CP__"